import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderBarVisibilityService {
  loaderBarVisibilityChanged = new Subject<boolean>();
}
